import { render, staticRenderFns } from "./OnlineGroup.vue?vue&type=template&id=dbb8d78c"
import script from "./OnlineGroup.vue?vue&type=script&lang=js"
export * from "./OnlineGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports